import { LitElement, html } from 'lit';

export class CookiePreferenceCategory extends LitElement {
  static properties = {
    title: { type: String },
    description: { type: String },
    checked: { type: Boolean },
    disabled: { type: Boolean },
    expanded: { type: Boolean },
  };

  createRenderRoot() {
    return this;
  }

  constructor() {
    super();
    this.expanded = false;
    this.disabled = false;
    this.checked = false;
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
    this.requestUpdate();
  }

  handleToggleChange(e) {
    if (this.disabled) {
      return;
    }

    this.checked = e.target.checked;
    this.dispatchEvent(
      new CustomEvent('cookie-preference-change', {
        bubbles: true,
        detail: { checked: this.checked },
      })
    );
  }

  render() {
    return html`
      <div
        class="cookie_preference_category ${this.expanded ? 'is_expanded' : ''}"
      >
        <div class="cookie_preference_category_header">
          <button
            type="button"
            class="cookie_preference_category_toggle"
            @click=${this.toggleExpanded}
            aria-expanded=${this.expanded ? 'true' : 'false'}
          >
            <span class="cookie_preference_category_arrow" aria-hidden="true">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                focusable="false"
              >
                <path
                  d="M2 4L6 8L10 4"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </span>
            <span class="cookie_preference_category_title">${this.title}</span>
          </button>
          <label class="cookie_preference_category_switch">
            <input
              type="checkbox"
              .checked=${this.checked}
              ?disabled=${this.disabled}
              @change=${this.handleToggleChange}
            />
            <span class="cookie_preference_category_switch_slider"></span>
          </label>
        </div>
        <div class="cookie_preference_category_description">
          <div class="cookie_preference_category_description_inner">
            ${this.description}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define(
  'cookie-preference-category',
  CookiePreferenceCategory
);
